var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomelight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 19.8335C16.9671 20.5596 15.7419 21.0002 14.3999 21.0002C13.058 21.0002 11.8327 20.5596 10.8999 19.8335",
    stroke: "#003636",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14335 15.4159C2.7315 12.7358 2.52557 11.3957 3.03226 10.2078C3.53895 9.0198 4.66309 8.207 6.91139 6.5814L8.59122 5.36683C11.3881 3.34461 12.7865 2.3335 14.4001 2.3335C16.0136 2.3335 17.4121 3.34461 20.2089 5.36683L21.8887 6.5814C24.137 8.207 25.2612 9.0198 25.7679 10.2078C26.2746 11.3957 26.0686 12.7358 25.6568 15.4159L25.3056 17.7013C24.7217 21.5006 24.4298 23.4002 23.0672 24.5335C21.7047 25.6668 19.7127 25.6668 15.7287 25.6668H13.0714C9.08745 25.6668 7.09546 25.6668 5.7329 24.5335C4.37034 23.4002 4.07841 21.5006 3.49456 17.7013L3.14335 15.4159Z",
    stroke: "#003636",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelight);
export default __webpack_public_path__ + "static/media/homelight.d70b094dd8e75cc0f60739a1980868d5.svg";
export { ForwardRef as ReactComponent };